import {css} from "@panda/css";

import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {ExpandablePanel} from "./atoms/ExpandablePanel";
import {MapLayerButtons} from "./MapLayerButtons";

interface IProps {
    transformRoutes: IOSMPoisRoutesGrouped[] | null;
    isOpen: boolean;
    handleClose: () => void;
}

export const ExpandablePanelMapLayers = (props: IProps) => {
    return (
        <ExpandablePanel
            isOpen={props.isOpen}
            handleClose={props.handleClose}
            className={expandableContentMapLayersStyle}
            textContentClassName={modalContentTextStyle}
        >
            <MapLayerButtons transportRoutes={props.transformRoutes} />
        </ExpandablePanel>
    );
};

const expandableContentMapLayersStyle = css({
    width: "100%",
    paddingTop: 4,
    paddingBottom: 2,
    paddingLeft: 3,
    paddingRight: 3,
    backgroundColor: "var(--colors-white)"
});

const modalContentTextStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    height: "auto"
});
import {css} from "@panda/css";

import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {ExpandablePanel} from "./atoms/ExpandablePanel";
import {MapLayerButtons} from "./MapLayerButtons";

interface IProps {
    transformRoutes: IOSMPoisRoutesGrouped[] | null;
    isOpen: boolean;
    handleClose: () => void;
}

export const ExpandablePanelMapLayers = (props: IProps) => {
    return (
        <ExpandablePanel
            isOpen={props.isOpen}
            handleClose={props.handleClose}
            className={expandableContentMapLayersStyle}
            textContentClassName={modalContentTextStyle}
        >
            <MapLayerButtons transportRoutes={props.transformRoutes} />
        </ExpandablePanel>
    );
};

const expandableContentMapLayersStyle = css({
    width: "100%",
    paddingTop: 4,
    paddingBottom: 2,
    paddingLeft: 3,
    paddingRight: 3,
    backgroundColor: "var(--colors-white)"
});

const modalContentTextStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    height: "auto"
});
